import { foodMenuLabels, menuFood } from "./food"
import { menuSoftDrinkLabels, menuSoftDrink } from "./soft-drinks"
import { menuAlcoholDrinkLabels, menuAlcoholDrink } from "./alcohol-drinks"

export const types = [
  { id: 1, value: "food", label: "Food" },
  { id: 2, value: "soft_drinks", label: "Soft Drinks" },
  { id: 3, value: "alcohol_drinks", label: "Alcohol Drinks" },
]

export const labels = {
  food: foodMenuLabels,
  soft_drinks: menuSoftDrinkLabels,
  alcohol_drinks: menuAlcoholDrinkLabels,
}

export const menu = {
  food: menuFood,
  soft_drinks: menuSoftDrink,
  alcohol_drinks: menuAlcoholDrink,
}
